<template>
  <div class="result-size-reco-noo-cleed baseline">
    <Subtitles :value-text="text" />
    <ButtonForLoop :buttons-list="buttonsList" :style-value-buttons="styleValueButtons" :class-name-buttons="classNameButtons" :class-grid="classGrid" @update-input="updateInput" />
  </div>
</template>

<script>
import Subtitles from "@/components/modal/ui/Subtitles.vue";
import ButtonForLoop from "@/components/modal/ui/ButtonForLoop.vue";

export default {
  name: "TextAndButtons",
  components: {
    Subtitles,
    ButtonForLoop,
  },
  props: {
    text: {
      type: String,
      default: "",
    },
    buttonsList: {
      type: Array,
      default: () => {},
    },
    nextSelectedOption: {
      type: String,
      default: "",
    },
    styleValueButtons: {
      type: String,
      default: "",
    },
    classNameButtons: {
      type: String,
      default: "",
    },
    classGrid: {
      type: String,
      default: "",
    },
  },
  mounted() {
  },
  methods: {
    updateInput(value)
    {
      this.$emit("update-input", value);
      this.$emit("update-selected-option", this.nextSelectedOption);
    }
  },

};
</script>
